{
  "intro": {
    "greeting": "Hello",
    "projects": "Projects",
    "contact": "Contact",
    "me": "I'm"
  }
}